import * as moment from 'moment';
import { pluralize } from 'journalize';

let today = moment();

// change these if the dates change
// the format moments of the date must match the format you tell moment
let registerToVoteDeadline = moment('2020-02-03', 'YYYY-MM-DD'),
  earlyVotingDeadline = moment('2020-02-18', 'YYYY-MM-DD'),
  texasPrimaries = moment('2020-03-03', 'YYYY-MM-DD');

// we add one day because the day of each deadline also counts
let registerToVoteDiff = registerToVoteDeadline.diff(today, 'days') + 1,
  earlyVotingDeadlineDiff = earlyVotingDeadline.diff(today, 'days') + 1,
  texasPrimariesDiff = texasPrimaries.diff(today, 'days') + 1;

// select days containers
let registerToVoteSlot = document.querySelector('#register-to-vote-slot'),
  earlyVotingSlot = document.querySelector('#early-voting-slot'),
  texasPrimariesSlot = document.querySelector('#texas-primaries-slot');

// select notes containers
let registerToVoteNote = document.querySelector('#register-to-vote-note'),
  earlyVotingNote = document.querySelector('#early-voting-note'),
  texasPrimariesNote = document.querySelector('#texas-primaries-note');

// if the deadlines have passed, set the text content to 0 days
if (registerToVoteDiff <= 0) {
  registerToVoteSlot.textContent = '0 days';
  registerToVoteSlot.className += ' date-passed';
  registerToVoteNote.className += ' date-passed';
} else if (registerToVoteDiff == 1) {
  registerToVoteSlot.textContent = 'Today';
  registerToVoteNote.textContent = 'is the registration deadline';
} else {
  registerToVoteSlot.textContent = `${registerToVoteDiff} day${pluralize(
    registerToVoteDiff
  )}`;
}

if (earlyVotingDeadlineDiff <= 0) {
  earlyVotingSlot.textContent = '0 days';
  earlyVotingSlot.className += ' date-passed';
  earlyVotingNote.className += ' date-passed';
} else {
  earlyVotingSlot.textContent = `${earlyVotingDeadlineDiff} day${pluralize(
    earlyVotingDeadlineDiff
  )}`;
}

if (texasPrimariesDiff <= 0) {
  texasPrimariesSlot.textContent = '0 days';
  texasPrimariesSlot.className += ' date-passed';
  texasPrimariesNote.className += ' date-passed';
} else {
  texasPrimariesSlot.textContent = `${texasPrimariesDiff} day${pluralize(
    texasPrimariesDiff
  )}`;
}
